import * as React from "react";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { useToggle } from "react-use";
import { SaveToSnapshotCollectionModal } from "@/modules/snapshots/modals/saveToSnapshotCollection";

interface BusinessReportOutcomeExportProps {
  businessReportOutcome: BusinessReportOutcome;
}

export const BusinessReportOutcomeSaveToCollection: React.FC<BusinessReportOutcomeExportProps> = ({
  businessReportOutcome,
}) => {
  const [isOpen, toggleIsOpen] = useToggle(false);

  return (
    <>
      {isOpen && (
        <SaveToSnapshotCollectionModal
          businessReportOutcome={businessReportOutcome}
          isOpen={isOpen}
          setIsOpen={toggleIsOpen}
        />
      )}
      <Button onClick={toggleIsOpen} variant="outline" size="sm">
        <Save className="mr-1.5 size-4" />
        Save to Collection
      </Button>
    </>
  );
};
